import React from 'react'
import { BasicFeature } from '@scentregroup/shared/hub-components/basic-feature'
import { ContentDetail } from '../../../lib/get-content-detail'
import { SGPageTemplate } from '@scentregroup/shared/types/page-templates'
import { Template } from '@scentregroup/shared/components/page-templates/template'
import { isMemberExclusive } from '@scentregroup/shared/helpers/is-member-exclusive'

export function NationalOfferContentDetail({
  template,
  content,
}: {
  template?: SGPageTemplate
  content: ContentDetail['nationalOffer']
}): JSX.Element {
  const { title, bodyCopy: body, startAt, endAt, highlightAttribute } = content
  const supportingColor = content?.heroImageSet?.masterSupportingColour
  const heroImage = content?.heroImageSet?.master?.url
  const termsAndConditions = content?.termsAndConditions || undefined

  return (
    <>
      <BasicFeature
        title={title}
        body={body}
        supportingColor={supportingColor}
        heroImage={heroImage}
        startAt={startAt}
        endAt={endAt}
        termsAndConditions={termsAndConditions}
        memberExclusive={isMemberExclusive(highlightAttribute)}
      />
      {template && <Template template={template} />}
    </>
  )
}
